// Slice 40 — Layout A wrapper: 240 px sidebar + main scroll area with the
// sticky staff stripe pinned to the top.

import type { ReactNode } from "react";
import type { StaffRole } from "../api/client";
import { useRouter } from "../router/router";
import { HqShellProvider } from "./HqShellContext";
import { Sidebar } from "./Sidebar";
import { StaffStripe } from "./StaffStripe";

export interface ShellProps {
  username: string;
  role: StaffRole;
  onSignedOut: () => void;
  renderScreen: (route: ReturnType<typeof useRouter>["route"]) => ReactNode;
}

export function Shell({ username, role, onSignedOut, renderScreen }: ShellProps) {
  const { route } = useRouter();
  return (
    <HqShellProvider username={username} role={role} onSignedOut={onSignedOut}>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "240px 1fr",
          height: "100%",
          background: "var(--hq-bg)",
          color: "var(--hq-text)",
        }}
      >
        <Sidebar />
        <main
          className="hq-scroll"
          style={{
            minWidth: 0,
            minHeight: 0,
            overflow: "auto",
            position: "relative",
          }}
        >
          <StaffStripe />
          <div style={{ maxWidth: 1320, margin: "0 auto", padding: 24 }}>{renderScreen(route)}</div>
        </main>
      </div>
    </HqShellProvider>
  );
}
